// const CUSTOM_COMPANY_ID = -99;
// const DEFAULT_COMPANY_ID = -2;
// const GROUP_NAME_VARIATE_ID = -3;

function getData() {
    return Promise.all([
        this.getAgentInfo(this.agentId),
        this.isSubSite && this.getSubdomainAgents()
    ])
}

export async function asyncData() {
    await this.getCompanyInfo();
    await this.setCompanyName(this.companyNameId)
    await getData.call(this);
}

